// =============================================================================
// Fase 5.5 → Fase A — Step 2: Tipo di richiesta
// 5 pulsanti: nuova / rinnovo / fermo / contatto / cambio_veicolo
// Quando cambio_veicolo → sub-bivio "cambio" vs "vendita_rottamazione"
// =============================================================================
import React from "react";
import { Sparkles, RotateCw, Clock, Headphones, Replace, Car, Trash2 } from "lucide-react";

export function Step2TipoRichiesta({ state, setField }) {
  const opts = [
    {
      key: "nuova", icon: Sparkles, title: "Nuova polizza",
      desc: "Voglio assicurare un veicolo (nuovo, acquistato o cambio compagnia).",
    },
    {
      key: "rinnovo", icon: RotateCw, title: "Rinnovo polizza",
      desc: "Ho già una polizza in scadenza e voglio rinnovarla.",
    },
    {
      key: "fermo", icon: Clock,
      title: "Veicolo fermo / non assicurato da tempo",
      desc: "Devo riattivare l'assicurazione di un veicolo fermo da molto tempo.",
    },
    {
      key: "contatto", icon: Headphones,
      title: "Richiedi contatto da un esperto",
      desc: "Voglio parlare con un consulente prima di procedere.",
    },
    {
      // FASE A — nuovo 5° pulsante
      key: "cambio_veicolo", icon: Replace,
      title: "Cambio veicolo / Vendita / Rottamazione",
      desc: "Ho cambiato veicolo, oppure devo vendere/rottamare quello attuale.",
    },
  ];

  const subOpts = [
    {
      key: "cambio", icon: Car, title: "Cambio veicolo",
      desc: "Ho un nuovo veicolo e voglio spostare/aggiornare la polizza.",
    },
    {
      key: "vendita_rottamazione", icon: Trash2, title: "Vendita o rottamazione",
      desc: "Voglio disdire la polizza perché il veicolo è stato venduto o rottamato.",
    },
  ];

  const onCambioVeicolo = state.tipo_richiesta === "cambio_veicolo";

  return (
    <div className="space-y-4" data-testid="rca-step2">
      <div>
        <h2 className="text-lg sm:text-xl font-semibold text-[#0F1F14]">
          Quale tipo di richiesta vuoi effettuare?
        </h2>
        <p className="text-sm text-[#4A5E51] mt-1">
          Scegli l&apos;opzione che descrive meglio la tua situazione.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {opts.map((o) => {
          const on = state.tipo_richiesta === o.key;
          const Icon = o.icon;
          return (
            <button
              key={o.key}
              type="button"
              onClick={() => {
                setField("tipo_richiesta", o.key);
                // reset sub_operazione se cambio direzione
                if (o.key !== "cambio_veicolo") setField("sub_operazione", "");
              }}
              data-testid={`rca-tipo-${o.key}`}
              className={`text-left rounded-2xl border-2 p-5 transition-all ${
                on
                  ? "border-[var(--brand-accent,#163321)] bg-[#163321]/5 ring-2 ring-[var(--brand-accent,#163321)]/20"
                  : "border-[#E5E2DB] bg-white hover:border-[#4A5E51]"
              }`}
            >
              <Icon className="w-6 h-6 text-[var(--brand-accent,#163321)] mb-2" />
              <div className="text-sm font-semibold text-[#0F1F14]">{o.title}</div>
              <div className="text-[12px] text-[#4A5E51] mt-1 leading-snug">{o.desc}</div>
            </button>
          );
        })}
      </div>

      {/* FASE A — Sub-bivio Cambio Veicolo */}
      {onCambioVeicolo && (
        <div
          className="rounded-2xl border-2 border-[var(--brand-accent,#163321)]/30 bg-[#FAF9F5] p-4 space-y-3 mt-2"
          data-testid="rca-sub-operazione-block"
        >
          <div>
            <h3 className="text-sm font-semibold text-[#0F1F14]">
              Indicaci il tipo di operazione da gestire
            </h3>
            <p className="text-[12px] text-[#4A5E51] mt-1">
              A seconda del caso ti chiederemo documenti diversi (libretto del
              nuovo veicolo oppure IBAN per l&apos;eventuale rimborso).
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {subOpts.map((s) => {
              const on = state.sub_operazione === s.key;
              const Icon = s.icon;
              return (
                <button
                  key={s.key}
                  type="button"
                  onClick={() => setField("sub_operazione", s.key)}
                  data-testid={`rca-sub-op-${s.key}`}
                  className={`text-left rounded-xl border-2 p-4 transition-all ${
                    on
                      ? "border-[var(--brand-accent,#163321)] bg-white ring-2 ring-[var(--brand-accent,#163321)]/20"
                      : "border-[#E5E2DB] bg-white hover:border-[#4A5E51]"
                  }`}
                >
                  <Icon className="w-5 h-5 text-[var(--brand-accent,#163321)] mb-1.5" />
                  <div className="text-sm font-semibold text-[#0F1F14]">{s.title}</div>
                  <div className="text-[11px] text-[#4A5E51] mt-0.5 leading-snug">{s.desc}</div>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
